/**

 * Maps admin parcel history + cost API into PaymentSlip paymentData shape.

 */

function sumDetailSubtotals(details) {

  return (details || []).reduce(

    (sum, d) => sum + (Number(d.subTotal) || 0),

    0,

  );

}



export function buildAdminPaymentSlipData(parcel, costData = {}) {

  const details = parcel?.details || [];

  const first = details[0] || {};



  const subTotal = Number(

    costData.subTotal ?? sumDetailSubtotals(details),

  );

  const vatAmount = Number(costData.vaT_TaxAmount ?? 0);

  const discountAmount = Number(costData.discountAmount ?? 0);



  const currencyType = first.currencyType || costData.currencyType || "GBP";

  const symbol = first.symbol || costData.symbol || "£";



  const hasStripe = Boolean(parcel?.stripePaymentIntentId);

  const paymentTypeId = hasStripe

    ? "2"

    : String(costData.paymentTypeMethodId || "5");



  return {

    parcelId: parcel.parcelNo,

    recordSerialNo:

      costData.recordSerialNo ||

      costData.parcelRecordSerialNo ||

      String(parcel.parcelNo),

    bookingBarcodeNumber:

      costData.recordSerialNo ||

      costData.barcode ||

      String(parcel.parcelNo),

    currencyType,

    currencyTypeId: costData.currencyTypeId,

    currencyTypes: costData.currencyTypes,

    senderName: parcel.senderName || "",

    senderEmail: parcel.senderEmail || "",

    senderMobileNumber: parcel.senderPhone || "",

    senderPostCode: parcel.senderPostCode || "",

    senderAddress:

      costData.senderAdditionalAddressInfo ||

      [parcel.senderPostCode, first.parcelAdditionalInfo]

        .filter(Boolean)

        .join(" — ") ||

      "",

    senderCity: costData.senderCityId || "",

    senderCountry: costData.senderCountryId || "",

    receiverName: parcel.receiverName || "",

    receiverEmail: parcel.receiverEmail || "",

    receiverMobileNumber: parcel.receiverPhone || "",

    receiverPostCode: parcel.receiverPostCode || "",

    receiverAddress: costData.receiverAdditionalAddressInfo || "",

    receiverCity: costData.receiverCityId || "",

    receiverCountry: costData.receiverCountryId || "",

    paymentTypeId,

    stripePaymentIntentId: parcel.stripePaymentIntentId || "",

    stripePaymentMethod: parcel.stripePaymentMethod || "",

    stripeChargeId: parcel.stripeChargeId || "",

    cardBrand: parcel.cardBrand || "",

    cardLast4: parcel.cardLast4 || "",

    preset: first.dimensionName || "",

    productLength: "",

    productWidth: "",

    productHeight: "",

    productWeight: first.weightDescription || "",

    producDetails: details.map((d) => ({

      productGroupName: d.cargoTypeName || "—",

      productTypeName: d.shippingServiceName || d.routeName || "—",

      itemDescription:

        d.uniqItemDescription || d.parcelAdditionalInfo || "—",

      productValue: "0.00",

      productQty: 1,

      preset: d.dimensionName || "",

      itemLength: "",

      itemWidth: "",

      itemHeight: "",

      itemWeight: d.weightDescription || "",

    })),

    transitCost: [

      {

        totalCost: subTotal + vatAmount,

        totalCostWithoutVAT: subTotal,

        disCountedPercentageAmount: discountAmount,

        disCountedPercentage: costData.discountPercentage || 0,

        afterDiscountCost: Math.max(0, subTotal - discountAmount),

      },

    ],

    _adminMeta: {

      routeName: first.routeName,

      parcelStatusName: parcel.parcelStatusName,

      paymentStatus: first.paymentStatus,

      symbol,

      stripePaymentIntentId: parcel.stripePaymentIntentId,

      stripeChargeId: parcel.stripeChargeId,

    },

  };

}


